import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-handicap-type.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetHandicapTypeDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metHandicapTypeEntity = useAppSelector(state => state.metHandicapType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metHandicapTypeDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metHandicapType.detail.title">MetHandicapType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metHandicapTypeEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metHandicapType.code">Code</Translate>
            </span>
          </dt>
          <dd>{metHandicapTypeEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metHandicapType.name">Name</Translate>
            </span>
          </dt>
          <dd>{metHandicapTypeEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metHandicapType.nameAr">name Ar</Translate>
            </span>
          </dt>
          <dd>{metHandicapTypeEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metHandicapType.nameEn">name En</Translate>
            </span>
          </dt>
          <dd>{metHandicapTypeEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metHandicapType.status">Status</Translate>
            </span>
          </dt>
          <dd>{metHandicapTypeEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-handicap-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-handicap-type/${metHandicapTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetHandicapTypeDetail;
